<mat-card style="max-height: 900px; margin-top: 20px;">

    <mat-card-header style="margin-bottom: 20px">        
        <mat-card-title>RENDA VARIÁVEL</mat-card-title>
        <button 
            mat-mini-fab
            style=" margin-left: 10px"
            matTooltip="Gerar STVM PDF"
            (click)="gerarStvm()"
            *ngIf="length > 0">
            <mat-icon>print</mat-icon>
        </button>

        <!-- <button 
            mat-mini-fab
            style=" margin-left: 10px"
            matTooltip="Enviar STVM por E-mail"
            (click)="enviarEmailStvm()"
            *ngIf="length > 0">
            <mat-icon>email</mat-icon>
        </button> -->
    </mat-card-header>

    <mat-card-content>

        <ngx-datatable 
            #table 
            class='material striped' 
            [loadingIndicator]="loadingIndicator"
            [columns]="columns" 
            [columnMode]="'force'" 
            [headerHeight]="50"                       
            [footerHeight]="50" 
            [rowHeight]="'auto'"                   
            [rows]='rows'
            [limit]="params.per_page"
            (sort)="onSort($event)"
        >

            <ngx-datatable-column name="Ativo" prop="ativo" [sortable]="true">
                <ng-template let-rowIndex="rowIndex" let-ativo="value" ngx-datatable-cell-template>
                    {{ativo}}
                </ng-template>
            </ngx-datatable-column> 

            <ngx-datatable-column name="Quantidade" prop="quantidade" [sortable]="true">
                <ng-template let-rowIndex="rowIndex" let-quantidade="value" ngx-datatable-cell-template>
                    {{ quantidade | number : '1.0-0' }}
                </ng-template>
            </ngx-datatable-column> 

            <ngx-datatable-column name="Cotação Atual" prop="cotacao_atual" [sortable]="true">
                <ng-template let-rowIndex="rowIndex" let-cotacao_atual="value" ngx-datatable-cell-template>
                    R$ {{ cotacao_atual | number : '1.2-2' }}
                </ng-template>
            </ngx-datatable-column> 

            <ngx-datatable-column name="Valor Financeiro" prop="vlr_financeiro" [sortable]="true">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    R$ {{ getValorFinanceiro(row)  | number : '1.2-2'}}
                </ng-template>
            </ngx-datatable-column> 
        </ngx-datatable>

        <div style="padding: 5px 10px">
            <mat-paginator 
                #paginator 
                [length]="length"
                [pageSize]="pageSize"                
                (page)="pageEvent($event)">
            </mat-paginator>
        </div>
        
    </mat-card-content>
</mat-card>